import React from 'react';
import { Toaster as Sonner } from 'sonner';
import { Icons } from '../Icons';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      loadingIcon={<Icons.LoadingSpinner />}
      icons={{
        warning: <Icons.StatusWarning />,
        info: <Icons.Info className="text-secondary-foreground" />,
        success: <Icons.StatusSuccess />,
        error: <Icons.StatusError />,
      }}
      theme="dark"
      richColors={true}
      toastOptions={{
        style: {
          width: '430px',
          right: '8px',
        },
        classNames: {
          toast: '!bg-customblue-50 !border-customgreen-100 !text-customblue-100',
          error: '!bg-customblue-50 !border-customgreen-100 !text-customblue-100',
          title: '!text-customblue-100',
          description: '!text-customblue-400',
          icon: '!text-customblue-200',
          actionButton:
            'bg-customblue-80 hover:bg-customblue-50 !text-white !border-0 !font-medium',
          closeButton: '!text-customblue-200 !border-customgreen-100',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
